<template>
  <div class="create-order-page">
    <header class="page-header">
      <h1>Criar Encomenda</h1>
    </header>

    <!-- Artigos adicionados -->
    <section>
      <h3>Artigos da Encomenda</h3>
      <div class="mb-3 text-right">
        <button class="btn btn-secondary" @click="addAllValidProducts">
          Gerar automaticamente
        </button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Nome</th>
            <th>Qtd</th>
            <th>Preço</th>
            <th>Preço Desc Uni:</th>
            <th>Total</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(arti, index) in articles"
            :key="`${arti.product_id || 'prod'}-${
              arti.id_request || 'req'
            }-${index}`"
          >
            <td>
              <span v-if="Array.isArray(arti.sku)">
                <span v-for="(sku, i) in arti.sku" :key="i">
                  <a :href="'/product/' + arti.id" target="_blank">{{ sku }}</a
                  ><br />
                </span>
              </span>
              <span v-else>
                <a :href="'/product/' + arti.id" target="_blank">{{
                  arti.sku
                }}</a>
              </span>
            </td>
            <td>{{ arti.name }}</td>
            <td>
              <input
                type="number"
                v-model.number="arti.quantity"
                :max="arti.qty_allocated"
                min="1"
                @input="validateQuantity(arti)"
              />
            </td>
            <td :class="{ 'text-muted': arti.price_final === null }">
              {{ arti.price_final !== null ? arti.price_final : '—' }}
            </td>
            <td :class="{ 'text-muted': arti.price_discount === null }">
              {{ arti.price_discount !== null ? arti.price_discount : '—' }}
            </td>
            <td>
              {{ (arti.quantity * (arti.price_discount || 0)).toFixed(2) }}
            </td>
            <td>
              <button class="btn btn-danger" @click="removeProduct(index)">
                Remover
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="total-row">
        <strong>Total:</strong>
        {{
          articles
            .reduce((sum, a) => sum + a.quantity * (a.price_discount || 0), 0)
            .toFixed(2)
        }}
        AED
      </div>
    </section>

    <hr />

    <!-- Envio -->
    <!-- <section class="shipping-section">
      <div class="form-group">
        <label>Transportadora</label>
        <select v-model="shippingCompany" class="form-control">
          <option value="Free Shipping">Envio Gratuito</option>
          <option value="DHL">DHL</option>
          <option value="FedEx">FedEx</option>
          <option value="CTT Expresso">CTT Expresso</option>
          <option value="CTT">CTT</option>
          <option value="Outro">Outro</option>
        </select>
      </div>
      <div class="form-group">
        <label>Total Envio (€)</label>
        <input
          type="number"
          class="form-control"
          v-model.number="shippingTotal"
          step="0.01"
        />
      </div>
    </section> -->

    <div class="text-center mt-3">
      <button class="btn btn-success submit-button" @click="createOrder">
        Submeter Encomenda
      </button>
    </div>

    <hr />

    <!-- Lista de Pedidos -->
    <section class="requests-list">
      <div v-if="requests.length == 0">Sem pedidos disponíveis.</div>
      <div class="accordion-grid">
        <div
          v-for="(req, i) in requests"
          :key="
            req && req.our_product
              ? req.our_product.prod_id + '-' + req.request.id + '-' + i
              : i
          "
          class="accordion-item"
          :class="{
            'picking-complete':
              req.picking_info.qty_asked - req.picking_info.qty_allocated <= 0,
            'picking-zero': req.picking_info.qty_allocated == 0,
            'picking-partial':
              req.picking_info.qty_allocated > 0 &&
              req.picking_info.qty_asked - req.picking_info.qty_allocated > 0,
          }"
        >
          <span class="badge-id">#{{ req.request.id }}</span>
          <p class="badge-date">
            {{ new Date(req.request.created_at).toLocaleDateString('pt-PT') }}
          </p>

          <div class="text-center mb-2">
            <span
              class="badge"
              :class="
                req.request.type === 'normal'
                  ? 'badge-success'
                  : 'badge-warning'
              "
            >
              {{ req.request.type ? req.request.type.toUpperCase() : 'N/A' }}
            </span>
          </div>

          <div class="accordion-header">
            <a :href="req.our_product.img" target="_blank">
              <img
                v-if="req.our_product.img"
                :src="req.our_product.img"
                alt="Imagem do Produto"
                class="product-img-large"
                @error="handleImageError"
              />
            </a>
            <div class="summary">
              <p>
                <strong>{{ req.our_product.name }}</strong>
              </p>
              <p>
                SKU:
                <span v-if="Array.isArray(req.our_product.sku)">
                  <span v-for="(sku, idx) in req.our_product.sku" :key="idx">
                    <a
                      :href="'/product/' + req.our_product.prod_id"
                      target="_blank"
                      >{{ sku }}</a
                    ><br />
                  </span>
                </span>
                <span v-else>
                  <a
                    :href="'/product/' + req.our_product.prod_id"
                    target="_blank"
                    >{{ req.our_product.sku }}</a
                  >
                </span>
              </p>
              <p>Quantidade: {{ req.picking_info.qty_asked }}</p>
              <p>
                Preço:
                <span
                  :class="{ 'text-muted': req.request.price_final === null }"
                >
                  {{
                    req.request.price_final !== null
                      ? req.request.price_final
                      : '—'
                  }}
                </span>
                | Preço Desc Uni:
                <span
                  :class="{ 'text-muted': req.request.price_discount === null }"
                >
                  {{
                    req.request.price_discount !== null
                      ? req.request.price_discount
                      : '—'
                  }}
                </span>
              </p>
              <p>
                <span class="badge badge-info">
                  Stock: {{ req.our_product.stock }}
                </span>
              </p>
              <p>
                Picking:
                <span
                  v-if="
                    req.picking_info.qty_asked -
                      req.picking_info.qty_allocated <=
                    0
                  "
                >
                  ✅
                </span>
                <span v-else>
                  ❌ <br />
                  <strong>{{ req.picking_info.qty_allocated }}</strong> /
                  {{ req.picking_info.qty_asked }}
                </span>
              </p>
              <div class="text-center">
                <button
                  v-if="req.picking_info.qty_allocated > 0"
                  class="btn btn-primary card-btn"
                  @click="addProduct(req, i)"
                >
                  Adicionar Produto
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requests: [],
      requestsBackup: [],
      email: 'shebin.panikkaveetil@gmail.com',
      articles: [],
      shippingCompany: 'Free Shipping',
      shippingTotal: 0,
    };
  },
  methods: {
    async getRequests() {
      const response = await fetch(
        `${this.$store.state.apiUrl}clientRequest/requests/logistics`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          body: JSON.stringify({ client_email: this.email }),
        }
      );
      const data = await response.json();
      this.requests = data.requests;
      console.log('Requests:', this.requests);
      this.requestsBackup = JSON.parse(JSON.stringify(data.requests));
    },
    addAllValidProducts() {
      let total = 0;
      const maxTotal = 980;

      // Set para guardar os IDs dos pedidos processados
      const processedRequestIds = new Set();

      this.requests.forEach((req, index) => {
        // Validação de segurança se o req veio mal formatado
        if (!req || !req.request || !req.our_product) return;

        const already = this.articles.some(
          (a) =>
            String(a.id_request) === String(req.request.id) &&
            String(a.product_id) === String(req.our_product.prod_id)
        );

        if (already) return;

        const qtyAvailable = Number(req.picking_info?.qty_allocated || 0);
        const price = Number(req.request?.price_discount || 0);

        if (qtyAvailable > 0 && price > 0) {
          const maxQty = Math.floor((maxTotal - total) / price);
          if (maxQty <= 0) return;

          const qtyToAdd = Math.min(qtyAvailable, maxQty);
          const subtotal = +(price * qtyToAdd).toFixed(2);

          this.articles.push({
            id: req.our_product.prod_id,
            name: req.our_product.name,
            sku: Array.isArray(req.our_product.sku)
              ? req.our_product.sku[0]
              : req.our_product.sku,
            product_id: req.our_product.prod_id,
            variation_id: 0,
            quantity: qtyToAdd,
            tax_class: '',
            price: price,
            subtotal,
            subtotal_tax: '0.00',
            total: subtotal,
            total_tax: '0.00',
            taxes: [],
            meta: [],
            id_request: req.request.id,
            type: req.request.type,
            price_discount: price,
            price_final: Number(req.request.price_final || 0),
            qty_allocated: qtyAvailable,
            originalIndex: index,
          });

          this.requestsBackup.push(req);

          // Guarda o identificador do pedido processado
          processedRequestIds.add(
            `${req.request.id}-${req.our_product.prod_id}`
          );

          total += subtotal;
        }
      });

      // Atualiza a lista de requests de UMA SÓ VEZ no final
      // Evita re-renderizações intermédias corrompidas no DOM do Vue
      this.requests = this.requests.filter(
        (req) =>
          !processedRequestIds.has(
            `${req.request.id}-${req.our_product.prod_id}`
          )
      );
    },

    addProduct(req, index) {
      const already = this.articles.find(
        (a) =>
          a.id_request === req.request.id &&
          a.product_id === req.our_product.prod_id
      );
      if (already) return;

      const qtyAllocated = Number(req.picking_info.qty_allocated);
      const price = Number(req.request.price_final || 0);
      const price_discount = Number(req.request.price_discount || 0);

      this.articles.push({
        id: req.our_product.prod_id,
        name: req.our_product.name,
        sku: Array.isArray(req.our_product.sku)
          ? req.our_product.sku[0]
          : req.our_product.sku,
        product_id: req.our_product.prod_id,
        variation_id: 0,
        quantity: qtyAllocated,
        tax_class: '',
        price: price,
        subtotal: price * qtyAllocated,
        subtotal_tax: '0.00',
        total: price * qtyAllocated,
        total_tax: '0.00',
        taxes: [],
        meta: [],
        id_request: req.request.id,
        type: req.request.type,
        price_discount: price_discount,
        price_final: price,
        qty_allocated: qtyAllocated,
        originalIndex: index,
      });

      this.requestsBackup.push(req);
      const reqIndex = this.requests.findIndex(
        (r) =>
          r.request.id === req.request.id &&
          r.our_product.prod_id === req.our_product.prod_id
      );
      if (reqIndex !== -1) this.requests.splice(reqIndex, 1);
    },
    removeProduct(index) {
      const removed = this.articles.splice(index, 1)[0];
      if (removed && removed.originalIndex !== undefined) {
        const original = this.requestsBackup.find(
          (r) => r.request.id === removed.id_request
        );
        if (original) this.requests.splice(removed.originalIndex, 0, original);
      }
    },
    async createOrder() {
      if (!this.shippingCompany || this.shippingTotal === null) {
        return this.$swal.fire({
          icon: 'error',
          title: 'Informação em falta',
          text: 'Preencha os dados de envio.',
          toast: true,
          timer: 3000,
          showConfirmButton: false,
          position: 'top-end',
        });
      }

      if (this.articles.length === 0) {
        return this.$swal.fire({
          icon: 'warning',
          title: 'Sem artigos',
          text: 'Adicione pelo menos um produto à encomenda.',
          toast: true,
          timer: 3000,
          showConfirmButton: false,
          position: 'top-end',
        });
      }

      const shippingLines = [
        {
          method_id: this.shippingCompany,
          method_title: this.shippingCompany,
          total: this.shippingTotal,
          total_tax: '0.00',
          taxes: [],
        },
      ];

      this.$swal
        .fire({
          title: 'Criar Encomenda',
          icon: 'question',
          text: 'Tem a certeza que deseja criar a encomenda?',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            // Atualiza todos os artigos com base no desconto
            this.articles = this.articles.map((article) => {
              const price = Number(article.price_discount);
              const quantity = Number(article.quantity);
              const subtotal = +(price * quantity).toFixed(2); // mantém como número com 2 casas decimais

              return {
                ...article,
                price: +Number(price.toFixed(2)),
                subtotal,
                total: subtotal,
              };
            });

            // Calcula o total final da encomenda
            const total = this.articles
              .reduce((sum, article) => sum + article.total, 0)
              .toFixed(2);

            //Fazer a chamada para criar a encomenda
            const result = await fetch(
              `${this.$store.state.apiUrl}clientRequest/requests/logistics/order`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json; charset=utf-8',
                  Authorization: `Bearer ${this.$store.state.token}`,
                },
                body: JSON.stringify({
                  products: this.articles,
                  shippingCompany: this.shippingCompany,
                  shipping_lines: shippingLines,
                  total: total,
                  coin: 'AED',
                }),
              }
            );

            // Verifica se a resposta é bem-sucedida
            if (result.ok) {
              const data = await result.json();
              console.log(data);
              this.$swal.fire({
                icon: 'success',
                title: 'Encomenda Criada',
                text: `A encomenda foi criada com sucesso. ID: ${data.order_id}`,
                toast: true,
                timer: 3000,
                showConfirmButton: false,
                position: 'top-end',
              });
              this.articles = [];
              this.shippingCompany = '';
              this.shippingTotal = 0;
            } else {
              const errorData = await result.json();
              this.$swal.fire({
                icon: 'error',
                title: 'Erro ao criar encomenda',
                text: errorData.message || 'Erro desconhecido.',
                toast: true,
                timer: 3000,
                showConfirmButton: false,
                position: 'top-end',
              });
            }
          }
        });
    },
    handleImageError(e) {
      e.target.src =
        'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg';
    },
    validateQuantity(arti) {
      if (arti.quantity > arti.qty_allocated) {
        arti.quantity = arti.qty_allocated;
      }
      if (arti.quantity < 1) {
        arti.quantity = 1;
      }
    },
  },
  async created() {
    await this.getRequests();
  },
};
</script>

<style scoped>
.create-order-page {
  padding: 20px;
  font-family: 'Poppins', sans-serif;
}
.page-header {
  text-align: center;
  margin-bottom: 30px;
}
.requests-list {
  margin-top: 30px;
}
.accordion-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}
.accordion-item {
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 12px;
  background: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: box-shadow 0.2s ease;
}
.accordion-item.picking-complete {
  background-color: #e8fcee;
  border-color: #00c851;
}
.accordion-item.picking-zero {
  background-color: #fff0f0;
  border-color: #ff4d4f;
}

.accordion-item.picking-partial {
  background-color: #fffbe6;
  border-color: #ffc107;
}
.accordion-item:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.badge-id {
  background-color: #007bff;
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 10px;
}
.badge-date {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}
.product-img-large {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 10px;
}
.summary p {
  margin: 6px 0;
  font-size: 14px;
}
.table {
  width: 100%;
  text-align: center;
}
.total-row {
  text-align: right;
  margin-top: 10px;
  font-weight: bold;
  font-size: 16px;
}
.shipping-section {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  align-items: center;
}
.form-group {
  flex: 1;
}
.submit-button {
  font-size: 16px;
  padding: 10px 20px;
}
.card-btn {
  margin-top: 10px;
  font-size: 14px;
}
</style>
